import { Avatar, Badge, Box, Typography, createStyles, makeStyles } from '@material-ui/core';
import { ChatUserData, LastMessageData } from 'myfitworld-model';
import React from 'react';
import { DoneAll } from '@material-ui/icons';
import { useUserProvider } from '../../providers/UserProvider';
import { ProviderThemeType, useMfwThemeProvider } from 'myfitworld-utils';
import SimpleMenu from '../SimpleMenu';
import { ChatPreferenceOptionsProps } from './PreferenceChatDialog';
import { chatPreferences } from './preferenceFunctions';
import { isMobile } from 'react-device-detect';
import { format } from 'date-fns';

const createStylesForTheme = (theme: ProviderThemeType) =>
    makeStyles(() =>
      createStyles({
        chatContainer: {
            backgroundColor: theme.theme.mobBackground.backgroundLight,
            borderRadius: 5, 
            padding: 10, 
            cursor: 'pointer', 
            marginTop: 5,
            display:'flex',
            flexDirection:'row',
            alignItems:"center",
            justifyContent:"space-between",
        },
        rowDisplay:{
            display:'flex',
            flexDirection:'row',
        },
        columnDisplay:{
            display:'flex',
            flexDirection:'column',
            alignItems:'flex-start',
            justifyContent:'flex-start',
        },
        avatar:{
            width: 40, 
            height: 40,
        },
        name:{
            color: "inherit",
            variant:"h5",
            marginLeft: 10,
            fontWeight: 'bold',
            display:'flex',
            flexDirection:'row',
        },
        messageContainer:{
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-between',
            marginLeft:'14px',
        },
        typography_time:{
            fontSize:'13px',
            fontStyle:"italic"
        },
        container_right:{            
            minWidth:"20%",
            display:"flex",
            flexDirection:"column",
            alignItems:"flex-end"
        }
      })
    );

const UsersChat = ({userId, chatId, message, onClick, setChatPreferenceDialog, options, user, unread}: {
    userId: string, 
    chatId: string,
    message: LastMessageData, 
    onClick: (user: ChatUserData, chatId: string) => void, 
    setChatPreferenceDialog:({isOpen, selectedProp}:{isOpen:boolean, selectedProp: ChatPreferenceOptionsProps | undefined})=>void,
    options:any,
    user: ChatUserData,
    unread: number
}) => {
    const {theme, mfwMobTheme}= useMfwThemeProvider();
    const {user: authUser} = useUserProvider();
    const useStyles = createStylesForTheme(theme);
    const classes = useStyles();

    function handleSelect(label:string | undefined){
        let selectedDialog:ChatPreferenceOptionsProps|undefined = chatPreferences.find((cp)=> cp.label===label);
        if(selectedDialog){
            selectedDialog.selectedUserId = userId;
            selectedDialog.selectedUserName = user.name;
            selectedDialog.selectedChatId = chatId;
            setChatPreferenceDialog({isOpen: true, selectedProp: selectedDialog});
        }
    }

    function formatTime(inputDate: Date){    
        const currentDate = new Date();
        // Check if the input date is today
        const isToday = inputDate.toDateString() === currentDate.toDateString();
    
        if (isToday) {
            // Format as hh:mm
            return inputDate.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
        } else {
            // Format as dd.mm.yyyy
            return format(inputDate, "dd/MM/yyyy")
        }
    }
    
    return(
        <Box  className = {classes.chatContainer} onClick={() => onClick(user, chatId)}>
            <Box className = {classes.rowDisplay}>
                <Avatar className={classes.avatar} src={user?.avatarURL}/>
                <Box className={classes.columnDisplay}>
                    <Typography className={classes.name}>
                        {user.name}
                    </Typography>
                    <Box className={classes.messageContainer}>
                        {message.senderId === authUser?.id && <DoneAll style={{fontSize: 15, marginTop: 1, fill: message.read ? mfwMobTheme.text : mfwMobTheme.text400}}/>}
                        <Typography style={{fontSize: 13, marginLeft: 3}}>{message.text.length > 40 ? `${message.text.slice(0, isMobile ? 25 : 40)}...` : message.text}</Typography>
                    </Box>
                    <Badge badgeContent={unread} color="error"></Badge>
                </Box>
            </Box>
            {/* Archive or delete: */}
            <Box  className={classes.container_right}>
                <Typography className={classes.typography_time}>
                    {formatTime(message.createdAt)}
                </Typography>
                <Box style = {{width:"fit-content"}} onClick={(event) => event.stopPropagation()}>
                    <SimpleMenu
                        options={options}
                        onSelect={(label)=>{handleSelect(label)}}
                        disabled={false}
                    />
                </Box>
            </Box>
        </Box>
    );
};
export default UsersChat;